class GoldbackSetBuilder {

constructor() {
this.currentTab = 'build';
this.selectedProducts = new Map();
this.savedSets = [];
this.currentSetNumber = 1;
this.collectionQuantities = new Map();
this.collectionsData = new Map();
this.accessoriesHTML = '';
this.init();
}

init() {
this.storeCollectionsHTML();
this.storeAccessoriesHTML();
this.loadSavedSets();
this.setupTabs();
this.setupQuantityControls();
this.setupAccordions();
setTimeout(() => {
this.setupSliders();
}, 100);
this.setupButtons();
this.setupModal();
this.updateUI();
}

storeCollectionsHTML() {
const mainAccordions = document.getElementById('mainAccordions');
if (!mainAccordions) return;

const accordions = mainAccordions.querySelectorAll('.gsb-accordion');
accordions.forEach(accordion => {
const collectionHandle = accordion.getAttribute('data-collection');
this.collectionsData.set(collectionHandle, accordion.cloneNode(true));
});
}

storeAccessoriesHTML() {
const accessoriesSection = document.querySelector('.gsb-tab-panel[data-panel="build"] .gsb-accessories-section');
if (accessoriesSection) {
this.accessoriesHTML = accessoriesSection.cloneNode(true);
}
}

loadSavedSets() {
try {
const saved = localStorage.getItem('goldback_saved_sets');
const globalCounter = localStorage.getItem('goldback_global_set_counter');
            
if (globalCounter) {
this.currentSetNumber = parseInt(globalCounter);
} else {
this.currentSetNumber = 1;
}

if (saved) {
this.savedSets = JSON.parse(saved);
}
} catch (error) {
console.error('Error loading saved sets:', error);
}
}

saveSetsToStorage() {
try {
localStorage.setItem('goldback_saved_sets', JSON.stringify(this.savedSets));
localStorage.setItem('goldback_global_set_counter', this.currentSetNumber.toString());
} catch (error) {
console.error('Error saving sets:', error);
}
}

setupTabs() {
const tabs = document.querySelectorAll('.gsb-tab');
const panels = document.querySelectorAll('.gsb-tab-panel');

tabs.forEach(tab => {
tab.addEventListener('click', () => {
const targetTab = tab.getAttribute('data-tab');

tabs.forEach(t => t.classList.remove('active'));
panels.forEach(p => p.classList.remove('active'));

tab.classList.add('active');
const targetPanel = document.querySelector(`[data-panel="${targetTab}"]`);
if (targetPanel) {
targetPanel.classList.add('active');
}

this.currentTab = targetTab;

if (targetTab === 'build') {
this.clearCurrentSelection();
this.toggleBuilderVisibility(true);
}

setTimeout(() => {
this.initializeAllAccessoriesSliders();
document.querySelectorAll('.gsb-collection-slider').forEach(slider => {
if (slider.swiper) slider.swiper.update();
});
}, 100);
});
});
}

setupQuantityControls() {
document.addEventListener('click', (e) => {
if (e.target.closest('.select-product-btn-initial')) {
e.preventDefault();
e.stopPropagation();

const btn = e.target.closest('.select-product-btn-initial');
if (btn.disabled) return;

const card = btn.closest('.product-card-wrapper');
const savedSet = btn.closest('.gsb-saved-set');

if (savedSet) {
const setIndex = parseInt(savedSet.getAttribute('data-set-index'));
const productId = btn.getAttribute('data-product-id');
if (!isNaN(setIndex)) {
this.updateSavedSetQuantity(setIndex, productId, 1);
}
return;
}

card.classList.add('quantity-active');

const input = card.querySelector('.quantity-input');
if (input) {
input.value = 1;
this.selectProduct(btn, 1);
}
return;
}

if (e.target.closest('.quantity-minus')) {
e.preventDefault();
e.stopPropagation();

const btn = e.target.closest('.quantity-minus');
const productId = btn.getAttribute('data-product-id');
const setIndex = btn.getAttribute('data-set-index');

if (setIndex !== null) {
this.updateSavedSetQuantity(parseInt(setIndex), productId, -1);
} else {
this.updateQuantity(productId, -1);
}
return;
}

if (e.target.closest('.quantity-plus')) {
e.preventDefault();
e.stopPropagation();

const btn = e.target.closest('.quantity-plus');
const productId = btn.getAttribute('data-product-id');
const setIndex = btn.getAttribute('data-set-index');

if (setIndex !== null) {
this.updateSavedSetQuantity(parseInt(setIndex), productId, 1);
} else {
this.updateQuantity(productId, 1);
}
return;
}
});

document.addEventListener('input', (e) => {
if (e.target.classList.contains('quantity-input')) {
e.preventDefault();
e.stopPropagation();

const input = e.target;
const productId = input.getAttribute('data-product-id');
const setIndex = input.getAttribute('data-set-index');
let value = parseInt(input.value) || 0;

if (value < 0) value = 0;
if (value > 999) value = 999;

input.value = value;

if (setIndex !== null) {
const set = this.savedSets[parseInt(setIndex)];
if (set) {
const product = set.products.find(p => p.productId === productId);
if (product) {
product.quantity = value;

if (value === 0) {
set.products = set.products.filter(p => p.productId !== productId);
const card = input.closest('.product-card-wrapper');
card.classList.remove('quantity-active');
}

if (set.products.length === 0) {
this.savedSets.splice(parseInt(setIndex), 1);
this.showNotification('Set deleted (no products remaining)', 'success');
} else {
set.total = set.products.reduce((sum, p) => sum + (p.price * p.quantity), 0);
}

this.saveSetsToStorage();
this.renderSavedSets();
}
}
} else {
if (value === 0) {
this.removeProduct(productId);
this.syncProductUI(productId, 0);
} else {
const btn = input.closest('.product-card-wrapper').querySelector('.select-product-btn-initial');
this.selectProduct(btn, value);
}
}
}
});
}

updateQuantity(productId, change) {
const currentProduct = this.selectedProducts.get(productId);
let currentQty = currentProduct ? currentProduct.quantity : 0;

if (!currentProduct) {
const domInput = document.querySelector(`.quantity-input[data-product-id="${productId}"]:not([data-set-index])`);
if (domInput) currentQty = parseInt(domInput.value) || 0;
}

let newValue = currentQty + change;
if (newValue < 0) newValue = 0;
if (newValue > 999) newValue = 999;

if (newValue === 0) {
this.removeProduct(productId);
this.syncProductUI(productId, 0);
} else {
const btn = document.querySelector(`.select-product-btn-initial[data-product-id="${productId}"]`);
if (btn) {
this.selectProduct(btn, newValue);
}
}
}

syncProductUI(productId, quantity) {
const allInputs = document.querySelectorAll(`.quantity-input[data-product-id="${productId}"]:not([data-set-index])`);

allInputs.forEach(input => {
input.value = quantity;
const card = input.closest('.product-card-wrapper');

if (quantity > 0) {
card.classList.add('quantity-active');
} else {
card.classList.remove('quantity-active');
}
});
}

removeProduct(productId) {
this.selectedProducts.delete(productId);
this.updateCollectionQuantities();
}

selectProduct(btn, quantity) {
const productId = btn.getAttribute('data-product-id');
const variantId = btn.getAttribute('data-variant-id');
const title = btn.getAttribute('data-product-title');
const price = parseFloat(btn.getAttribute('data-product-price'));
const image = btn.getAttribute('data-product-image');

const card = btn.closest('.product-card-wrapper');
const accordion = card.closest('.gsb-accordion');
const collectionHandle = accordion ? accordion.getAttribute('data-collection') : 'accessories';

if (this.selectedProducts.has(productId)) {
const existing = this.selectedProducts.get(productId);
existing.quantity = quantity;
} else {
this.selectedProducts.set(productId, {
productId,
variantId,
title,
price,
image,
quantity,
collection: collectionHandle
});
}

this.syncProductUI(productId, quantity);
this.updateCollectionQuantities();
}

updateCollectionQuantities() {
this.collectionQuantities.clear();

this.selectedProducts.forEach(product => {
const collection = product.collection;
const current = this.collectionQuantities.get(collection) || 0;
this.collectionQuantities.set(collection, current + product.quantity);
});

const mainAccordions = document.getElementById('mainAccordions');
if (mainAccordions) {
mainAccordions.querySelectorAll('.gsb-accordion').forEach(accordion => {
const collectionHandle = accordion.getAttribute('data-collection');
const quantity = this.collectionQuantities.get(collectionHandle) || 0;
const countEl = accordion.querySelector('.quantity-count');
if (countEl) {
countEl.textContent = quantity;
}
});
}
}

setupAccordions() {
document.addEventListener('click', (e) => {
const trigger = e.target.closest('.gsb-accordion-trigger');
if (!trigger) return;

e.preventDefault();
e.stopPropagation();

const accordion = trigger.closest('.gsb-accordion');
const isActive = accordion.classList.contains('active');

const parentContainer = accordion.closest('.gsb-accordions, .gsb-saved-set-content');
if (parentContainer) {
parentContainer.querySelectorAll('.gsb-accordion').forEach(acc => {
acc.classList.remove('active');
});
}

if (!isActive) {
accordion.classList.add('active');
const slider = accordion.querySelector('.gsb-collection-slider');
if (slider && !slider.swiper) {
this.initializeSlider(slider);
}
}
});
}

setupSliders() {
document.querySelectorAll('.gsb-collection-slider').forEach(slider => {
const accordion = slider.closest('.gsb-accordion');
if (accordion && accordion.classList.contains('active')) {
this.initializeSlider(slider);
}
});
this.initializeAllAccessoriesSliders();
}

initializeAllAccessoriesSliders() {
const accessoriesSliders = document.querySelectorAll('.gsb-accessories-slider');
accessoriesSliders.forEach(slider => {
if (slider.swiper) {
slider.swiper.destroy(true, true);
}
this.initializeAccessoriesSlider(slider);
});
}

initializeAccessoriesSlider(slider) {
if (!slider) return;
if (typeof Swiper === 'undefined') return;

try {
new Swiper(slider, {
slidesPerView: 2,
spaceBetween: 20,
navigation: {
nextEl: '.gsb-accessories-next',
prevEl: '.gsb-accessories-prev',
},
breakpoints: {
640: { slidesPerView: 2, spaceBetween: 20 },
768: { slidesPerView: 3, spaceBetween: 24 },
1024: { slidesPerView: 4, spaceBetween: 24 },
},
});
} catch (error) {
console.error('Error initializing accessories slider:', error);
}
}

initializeSlider(slider) {
if (!slider || slider.swiper) return;
if (typeof Swiper === 'undefined') return;

try {
new Swiper(slider, {
slidesPerView: 2,
spaceBetween: 20,
navigation: {
nextEl: slider.querySelector('.swiper-button-next'),
prevEl: slider.querySelector('.swiper-button-prev'),
},
breakpoints: {
640: { slidesPerView: 2, spaceBetween: 20 },
768: { slidesPerView: 3, spaceBetween: 24 },
1024: { slidesPerView: 4, spaceBetween: 24 },
},
});
} catch (error) {
console.error('Error initializing collection slider:', error);
}
}

setupButtons() {
document.addEventListener('click', (e) => {
if (e.target.closest('[data-action="save-set"]')) this.saveCurrentSet();
if (e.target.closest('[data-action="proceed-predesigned"]')) this.proceedToCart('predesigned');
if (e.target.closest('[data-action="proceed-build"]')) this.proceedToCart('build');
if (e.target.closest('[data-action="create-another-set"]')) this.createAnotherSet();

if (e.target.closest('[data-action="delete-set"]')) {
e.preventDefault();
e.stopPropagation();
const btn = e.target.closest('[data-action="delete-set"]');
const index = parseInt(btn.getAttribute('data-set-index'));
const set = this.savedSets[index];
this.showDeleteModal(set.setName, index);
}
});
}

saveCurrentSet() {
if (this.selectedProducts.size === 0) {
this.showNotification('Please select products first', 'error');
return;
}

let total = 0;
const products = [];
const collectionBreakdown = new Map();
let accessoriesCount = 0;

this.selectedProducts.forEach(product => {
total += product.price * product.quantity;
products.push({...product});

const collection = product.collection;
const current = collectionBreakdown.get(collection) || 0;
collectionBreakdown.set(collection, current + product.quantity);

// Count accessories
if (collection === 'accessories') {
accessoriesCount += product.quantity;
}
});

const newSet = {
setId: `set_${Date.now()}`,
setNumber: this.currentSetNumber,
setName: `Set ${this.currentSetNumber}`,
products: products,
total: total,
goldbacks: Array.from(this.collectionQuantities.values()).reduce((a, b) => a + b, 0) - accessoriesCount,
accessories: accessoriesCount,
collectionBreakdown: Object.fromEntries(collectionBreakdown),
createdAt: new Date().toISOString()
};

this.savedSets.push(newSet);
this.currentSetNumber++;

this.saveSetsToStorage();
this.renderSavedSets();
this.clearCurrentSelection();
this.toggleBuilderVisibility(false); 

this.showNotification(`${newSet.setName} saved successfully!`, 'success');
}

createAnotherSet() {
this.clearCurrentSelection();
this.toggleBuilderVisibility(true);
this.showNotification('Ready to create a new set', 'success');
const firstAccordion = document.querySelector('#mainAccordions .gsb-accordion');
if (firstAccordion) {
firstAccordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
}

toggleBuilderVisibility(isVisible) {
const mainAccordions = document.getElementById('mainAccordions');
const footerButtons = document.querySelector('.gsb-footer-buttons--build');
const saveBtn = footerButtons?.querySelector('[data-action="save-set"]');
const createAnotherBtn = footerButtons?.querySelector('[data-action="create-another-set"]');
const accessoriesSection = document.querySelector('.gsb-tab-panel[data-panel="build"] .gsb-accessories-section');

if (isVisible) {
if(mainAccordions) mainAccordions.style.display = 'block';
if(accessoriesSection) accessoriesSection.style.display = 'block';

if(saveBtn) saveBtn.style.display = 'inline-flex';
if(createAnotherBtn) createAnotherBtn.style.display = 'none';
} else {
if(mainAccordions) mainAccordions.style.display = 'none';
if(accessoriesSection) accessoriesSection.style.display = 'none';

if(saveBtn) saveBtn.style.display = 'none';
if(createAnotherBtn) createAnotherBtn.style.display = 'inline-flex';
}
}

clearCurrentSelection() {
this.selectedProducts.clear();
this.collectionQuantities.clear();

document.querySelectorAll('.quantity-input:not([data-set-index])').forEach(input => {
input.value = 0;
const card = input.closest('.product-card-wrapper');
if(card) card.classList.remove('quantity-active');
});

this.updateCollectionQuantities();
}

renderSavedSets() {
    const container = document.getElementById('savedSetsContainer');
    if (!container) return;

    if (this.savedSets.length === 0) {
        container.innerHTML = '';
        return;
    }

    let html = '';

    this.savedSets.forEach((set, index) => {
        const totalItems = set.products.reduce((sum, p) => sum + p.quantity, 0);
        const price = (set.total / 100).toFixed(2);
        const goldbacksCount = set.goldbacks || 0;
        const accessoriesCount = set.accessories || 0;

        html += `
        <div class="gsb-saved-set" data-set-index="${index}">
            <div class="gsb-saved-set-header">
            <div class="gsb-saved-set--left">
                <div class="saved-set-title">
                    <h3>${set.setName}</h3>
                </div>
                <svg class="gsb-saved-set-separator" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="#B8B9BD"></circle>
                </svg>

                <div class="saved-set-info">
                    <span>Goldbacks: ${goldbacksCount}</span>
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="4" cy="4" r="4" fill="#B8B9BD"></circle>
                    </svg>
                    <span>Accessories: ${accessoriesCount}</span>
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="4" cy="4" r="4" fill="#B8B9BD"></circle>
                    </svg>
                    <span>Price: $${price}</span>
                </div>
                    <svg class="gsb-saved-set-separator-line" width="2" height="20" viewBox="0 0 2 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line opacity="0.6" x1="1" y1="1" x2="1" y2="19" stroke="#6F6F6F" stroke-width="2" stroke-linecap="round"></line>
                    </svg>
                <div class="saved-set-actions">
                    <button type="button" class="saved-set-delete" data-action="delete-set" data-set-index="${index}">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 5.25H17.441C16.54 5.25 16.502 5.136 16.255 4.396L16.053 3.789C15.746 2.869 14.889 2.25 13.919 2.25H10.081C9.11099 2.25 8.253 2.868 7.947 3.789L7.745 4.396C7.498 5.137 7.46 5.25 6.559 5.25H3C2.586 5.25 2.25 5.586 2.25 6C2.25 6.414 2.586 6.75 3 6.75H4.298L5.065 18.249C5.213 20.474 6.57701 21.75 8.80701 21.75H15.194C17.423 21.75 18.787 20.474 18.936 18.249L19.703 6.75H21C21.414 6.75 21.75 6.414 21.75 6C21.75 5.586 21.414 5.25 21 5.25ZM9.37 4.263C9.473 3.956 9.75799 3.75 10.081 3.75H13.919C14.242 3.75 14.528 3.956 14.63 4.263L14.832 4.87C14.876 5.001 14.92 5.128 14.968 5.25H9.03C9.078 5.127 9.12301 5 9.16701 4.87L9.37 4.263ZM17.438 18.149C17.343 19.582 16.629 20.25 15.193 20.25H8.806C7.37 20.25 6.657 19.583 6.561 18.149L5.801 6.75H6.558C6.683 6.75 6.787 6.737 6.899 6.729C6.933 6.734 6.964 6.75 6.999 6.75H16.999C17.035 6.75 17.065 6.734 17.099 6.729C17.211 6.737 17.315 6.75 17.44 6.75H18.197L17.438 18.149ZM14.75 11V16C14.75 16.414 14.414 16.75 14 16.75C13.586 16.75 13.25 16.414 13.25 16V11C13.25 10.586 13.586 10.25 14 10.25C14.414 10.25 14.75 10.586 14.75 11ZM10.75 11V16C10.75 16.414 10.414 16.75 10 16.75C9.586 16.75 9.25 16.414 9.25 16V11C9.25 10.586 9.586 10.25 10 10.25C10.414 10.25 10.75 10.586 10.75 11Z" fill="#C62828"/></svg>
                    </button>
                    
                </div>
                </div>
                <div class="gsb-saved-set--right">
                    <svg class="accordion-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div class="gsb-saved-set-content">
                <div class="gsb-accordions">
                    ${this.renderSetCollections(set, index)}
                    ${this.renderSetAccessories(set, index)}
                </div>
            </div>
        </div>
        `;
    });

    container.innerHTML = html;
    this.setupSavedSetInteractions();
}


renderSetCollections(set, setIndex) {
let html = '';

this.collectionsData.forEach((accordionTemplate, collectionHandle) => {
if (collectionHandle === 'accessories') return; // Skip accessories as they'll be handled separately

const setProducts = set.products.filter(p => p.collection === collectionHandle);

const clonedAccordion = accordionTemplate.cloneNode(true);
const slides = clonedAccordion.querySelectorAll('.swiper-slide');

slides.forEach(slide => {
const card = slide.querySelector('.product-card-wrapper');
if (!card) return;

const productId = card.getAttribute('data-product-id');
const setProduct = setProducts.find(p => p.productId === productId);

card.removeAttribute('data-set-index');
card.classList.remove('quantity-active');

const input = card.querySelector('.quantity-input');
const plusBtn = card.querySelector('.quantity-plus');
const minusBtn = card.querySelector('.quantity-minus');

if (input) input.removeAttribute('data-set-index');
if (plusBtn) plusBtn.removeAttribute('data-set-index');
if (minusBtn) minusBtn.removeAttribute('data-set-index');

if (setProduct) {
card.classList.add('quantity-active');
card.setAttribute('data-set-index', setIndex);

if (input) {
input.value = setProduct.quantity;
input.setAttribute('value', setProduct.quantity);
input.setAttribute('data-set-index', setIndex);
}

if (plusBtn) plusBtn.setAttribute('data-set-index', setIndex);
if (minusBtn) minusBtn.setAttribute('data-set-index', setIndex);
} else {
if (input) {
input.value = 0;
input.setAttribute('value', 0);
}
}
});

const quantityCount = clonedAccordion.querySelector('.quantity-count');
if (quantityCount) {
const totalQty = setProducts.reduce((sum, p) => sum + p.quantity, 0);
quantityCount.textContent = totalQty;
}

html += clonedAccordion.outerHTML;
});

return html;
}

renderSetAccessories(set, setIndex) {
    if (!this.accessoriesHTML) return '';

    const setAccessories = set.products.filter(p => p.collection === 'accessories');
    
    // CHANGED: We clone the stored HTML, which IS the section itself. 
    // We do not need to querySelector inside it.
    const accessoriesSection = this.accessoriesHTML.cloneNode(true);

    if (accessoriesSection) {
      // Calculate total quantity for the badge
      const totalQuantity = setAccessories.reduce((sum, p) => sum + p.quantity, 0);

      // Create accordion structure for accessories
      const accordionHTML = `
            <div class="gsb-accordion" data-collection="accessories">
                <button class="gsb-accordion-trigger" type="button">
                    <span class="accordion-title">
                      <span class="collection-name">Accessories</span>
                      <span class="quantity-badge">Quantity selected: <strong class="quantity-count">${totalQuantity}</strong></span>
                    </span>
                    <svg class="accordion-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <div class="gsb-accordion-content">
                    <div class="swiper gsb-accessories-slider">
                        <div class="swiper-wrapper">
                            ${accessoriesSection.querySelector('.swiper-wrapper').innerHTML}
                        </div>
                        <div class="swiper-button-next gsb-accessories-next"></div>
                        <div class="swiper-button-prev gsb-accessories-prev"></div>
                    </div>
                </div>
            </div>
        `;

      // Create a temporary container to manipulate the DOM
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = accordionHTML;

      const accessoriesAccordion = tempDiv.firstElementChild;
      const slides = accessoriesAccordion.querySelectorAll('.swiper-slide');

      slides.forEach(slide => {
        const card = slide.querySelector('.product-card-wrapper');
        if (!card) return;

        const productId = card.getAttribute('data-product-id');
        const setProduct = setAccessories.find(p => p.productId === productId);

        // Reset previous attributes
        card.removeAttribute('data-set-index');
        card.classList.remove('quantity-active');

        const input = card.querySelector('.quantity-input');
        const plusBtn = card.querySelector('.quantity-plus');
        const minusBtn = card.querySelector('.quantity-minus');

        if (input) input.removeAttribute('data-set-index');
        if (plusBtn) plusBtn.removeAttribute('data-set-index');
        if (minusBtn) minusBtn.removeAttribute('data-set-index');

        // If product is in this set, update the UI
        if (setProduct) {
          card.classList.add('quantity-active');
          card.setAttribute('data-set-index', setIndex);

          if (input) {
            input.value = setProduct.quantity;
            input.setAttribute('value', setProduct.quantity);
            input.setAttribute('data-set-index', setIndex);
          }

          if (plusBtn) plusBtn.setAttribute('data-set-index', setIndex);
          if (minusBtn) minusBtn.setAttribute('data-set-index', setIndex);
        } else {
          if (input) {
            input.value = 0;
            input.setAttribute('value', 0);
          }
        }
      });

      return accessoriesAccordion.outerHTML;
    }

    return '';
  }

setupSavedSetInteractions() {
document.querySelectorAll('.gsb-saved-set-header').forEach(header => {
const newHeader = header.cloneNode(true);
header.parentNode.replaceChild(newHeader, header);

newHeader.addEventListener('click', (e) => {
if (e.target.closest('.saved-set-delete')) return;

e.preventDefault();
e.stopPropagation();

const savedSet = newHeader.closest('.gsb-saved-set');
const wasActive = savedSet.classList.contains('active');

document.querySelectorAll('.gsb-saved-set').forEach(s => {
s.classList.remove('active');
});

if (!wasActive) {
savedSet.classList.add('active');
// Initialize sliders when accordion opens
setTimeout(() => {
const sliders = savedSet.querySelectorAll('.gsb-collection-slider, .gsb-accessories-slider');
sliders.forEach(slider => {
if (!slider.swiper) {
if (slider.classList.contains('gsb-accessories-slider')) {
this.initializeAccessoriesSlider(slider);
} else {
this.initializeSlider(slider);
}
}
});
}, 100);
}
});
});
}

updateSavedSetQuantity(setIndex, productId, change) {
const set = this.savedSets[setIndex];
if (!set) return;

let product = set.products.find(p => p.productId === productId);
let productCollection = '';

if (!product && change > 0) {
const btn = document.querySelector(`#mainAccordions .select-product-btn-initial[data-product-id="${productId}"]`);

if (btn) {
const newProduct = {
productId: productId,
variantId: btn.getAttribute('data-variant-id'),
title: btn.getAttribute('data-product-title'),
price: parseFloat(btn.getAttribute('data-product-price')),
image: btn.getAttribute('data-product-image'),
quantity: 1,
collection: btn.closest('.gsb-accordion')?.getAttribute('data-collection') || 'accessories'
};
set.products.push(newProduct);
product = newProduct;
productCollection = newProduct.collection;
} else {
const savedSetBtn = document.querySelector(`.gsb-saved-set[data-set-index="${setIndex}"] .select-product-btn-initial[data-product-id="${productId}"]`);
if (savedSetBtn) {
const newProduct = {
productId: productId,
variantId: savedSetBtn.getAttribute('data-variant-id'),
title: savedSetBtn.getAttribute('data-product-title'),
price: parseFloat(savedSetBtn.getAttribute('data-product-price')),
image: savedSetBtn.getAttribute('data-product-image'),
quantity: 1,
collection: savedSetBtn.closest('.gsb-accordion')?.getAttribute('data-collection') || 'accessories'
};
set.products.push(newProduct);
product = newProduct;
productCollection = newProduct.collection;
}
}
} else if (product) {
productCollection = product.collection;
product.quantity += change;

if (product.quantity <= 0) {
set.products = set.products.filter(p => p.productId !== productId);
product = null;
}
} else {
return;
}

if (set.products.length === 0) {
this.savedSets.splice(setIndex, 1);
this.showNotification('Set deleted (no products remaining)', 'success');
this.saveSetsToStorage();
this.renderSavedSets();
return;
}

// Update set statistics
set.total = set.products.reduce((sum, p) => sum + (p.price * p.quantity), 0);
const accessoriesCount = set.products.filter(p => p.collection === 'accessories').reduce((sum, p) => sum + p.quantity, 0);
const goldbacksCount = set.products.filter(p => p.collection !== 'accessories').reduce((sum, p) => sum + p.quantity, 0);
set.accessories = accessoriesCount;
set.goldbacks = goldbacksCount;

this.saveSetsToStorage();

const setEl = document.querySelector(`.gsb-saved-set[data-set-index="${setIndex}"]`);
if (!setEl) return;

const totalItems = set.products.reduce((sum, p) => sum + p.quantity, 0);
const price = (set.total / 100).toFixed(2);
const infoSpans = setEl.querySelectorAll('.saved-set-info span');
if (infoSpans[0]) infoSpans[0].textContent = `Items: ${totalItems}`;
// if (infoSpans[1]) infoSpans[1].textContent = `Goldbacks: ${goldbacksCount}`;
if (infoSpans[2]) infoSpans[2].textContent = `Accessories: ${accessoriesCount}`;
if (infoSpans[3]) infoSpans[3].textContent = `Price: $${price}`;

const card = setEl.querySelector(`.product-card-wrapper[data-product-id="${productId}"]`);
if (card) {
const input = card.querySelector(`.quantity-input[data-product-id="${productId}"]`);
const newQty = product ? product.quantity : 0;

if (input) input.value = newQty;

if (newQty > 0) {
card.classList.add('quantity-active');
card.querySelector('.quantity-plus')?.setAttribute('data-set-index', setIndex);
card.querySelector('.quantity-minus')?.setAttribute('data-set-index', setIndex);
if (input) input.setAttribute('data-set-index', setIndex);
} else {
card.classList.remove('quantity-active');
card.querySelector('.quantity-plus')?.removeAttribute('data-set-index');
card.querySelector('.quantity-minus')?.removeAttribute('data-set-index');
if (input) input.removeAttribute('data-set-index');
}
}

if (productCollection) {
const collectionAccordion = setEl.querySelector(`.gsb-accordion[data-collection="${productCollection}"]`);
if (collectionAccordion) {
const collectionProducts = set.products.filter(p => p.collection === productCollection);
const collectionQty = collectionProducts.reduce((sum, p) => sum + p.quantity, 0);
const countEl = collectionAccordion.querySelector('.quantity-count');
if (countEl) countEl.textContent = collectionQty;
}
}
}

setupModal() {
const modal = document.getElementById('deleteModal');
if(!modal) return;

const confirmBtn = document.getElementById('confirmDelete');
const cancelBtn = document.getElementById('cancelDelete');
const overlay = modal.querySelector('.gsb-modal-overlay');

const newConfirmBtn = confirmBtn.cloneNode(true);
confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);

newConfirmBtn.addEventListener('click', () => {
const index = parseInt(modal.getAttribute('data-delete-index'));
if (index >= 0) {
this.deleteSet(index);
}
modal.classList.remove('active');
modal.removeAttribute('data-delete-index');
});

const closeModal = () => {
modal.classList.remove('active');
modal.removeAttribute('data-delete-index');
};

const newCancelBtn = cancelBtn.cloneNode(true);
cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);
newCancelBtn.addEventListener('click', closeModal);

const newOverlay = overlay.cloneNode(true);
overlay.parentNode.replaceChild(newOverlay, overlay);
newOverlay.addEventListener('click', closeModal);
}

showDeleteModal(setName, index) {
const modal = document.getElementById('deleteModal');
if(!modal) return;
document.getElementById('deleteSetName').textContent = setName;
modal.classList.add('active');
modal.setAttribute('data-delete-index', index);
}

deleteSet(index) {
this.savedSets.splice(index, 1);
this.saveSetsToStorage();
this.renderSavedSets();
this.showNotification('Set deleted successfully', 'success');
}

async proceedToCart(tab) {
let itemsToAdd = [];
const loadingButton = document.querySelector(`[data-action="proceed-${tab}"]`);

if (tab === 'build') {
// Add Saved Sets with set properties
this.savedSets.forEach(set => {
set.products.forEach(product => {
itemsToAdd.push({
id: product.variantId,
quantity: product.quantity,
properties: {
'_set_id': set.setId,
'_set_name': set.setName,
'_set_number': set.setNumber,
'_collection': product.collection
}
});
});
});

// Add Current "Build" (if any) with set properties
if (this.selectedProducts.size > 0) {
const currentSetInfo = {
setId: `set_${Date.now()}`,
setName: `Set ${this.currentSetNumber}`,
setNumber: this.currentSetNumber
};

this.currentSetNumber++;
this.saveSetsToStorage();

this.selectedProducts.forEach(product => {
itemsToAdd.push({
id: product.variantId,
quantity: product.quantity,
properties: {
'_set_id': currentSetInfo.setId,
'_set_name': currentSetInfo.setName,
'_set_number': currentSetInfo.setNumber,
'_collection': product.collection
}
});
});
}
}
else if (tab === 'predesigned') {
// Add Pre-designed items WITHOUT set properties
const selectedCards = document.querySelectorAll('[data-panel="predesigned"] .product-card-wrapper.quantity-active');
selectedCards.forEach(card => {
const input = card.querySelector('.quantity-input');
const quantity = parseInt(input.value) || 0;
const btn = card.querySelector('.select-product-btn-initial');

if (quantity > 0 && btn) {
itemsToAdd.push({
id: btn.getAttribute('data-variant-id'),
quantity: quantity
});
}
});
}

if (itemsToAdd.length === 0) {
this.showNotification('Please select products first', 'error');
return;
}

if (loadingButton) loadingButton.classList.add('loading');

try {
const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
},
body: JSON.stringify({ items: itemsToAdd })
});

if (response.ok) {
this.showNotification('Products added to cart!', 'success');

const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
const cart = await cartResponse.json();
this.updateCartCount(cart.item_count);

// Clear "Build" tab on success
if (tab === 'build') {
this.savedSets = [];
this.saveSetsToStorage();
this.clearCurrentSelection();
this.renderSavedSets();
this.toggleBuilderVisibility(true);
}

setTimeout(() => {
window.location.href = '/cart';
}, 1000);
} else {
throw new Error('Failed to add to cart');
}
} catch (error) {
console.error('Error adding to cart:', error);
this.showNotification('Error adding to cart. Please try again.', 'error');
} finally {
if (loadingButton) loadingButton.classList.remove('loading');
}
}

updateCartCount(count) {
const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
cartCountElements.forEach(el => {
el.textContent = count;
});
}

updateUI() {
this.renderSavedSets();
this.updateCollectionQuantities();

this.selectedProducts.forEach(product => {
this.syncProductUI(product.productId, product.quantity);
});

if (this.savedSets.length > 0) {
this.toggleBuilderVisibility(false);
} else {
this.toggleBuilderVisibility(true);
}
}

showNotification(message, type = 'success') {
document.querySelectorAll('.gsb-notification').forEach(n => n.remove());

const notification = document.createElement('div');
notification.className = `gsb-notification gsb-notification--${type}`;
notification.textContent = message;
document.body.appendChild(notification);

setTimeout(() => notification.classList.add('show'), 10);

setTimeout(() => {
notification.classList.remove('show');
setTimeout(() => notification.remove(), 300);
}, 3000);
}
}

// CSS Injection
const notificationStyles = `
<style>
.gsb-notification {
position: fixed;
top: 20px;
right: 20px;
padding: 16px 24px;
border-radius: 8px;
font-size: 14px;
font-weight: 600;
z-index: 10000;
transform: translateX(400px);
transition: transform 0.3s ease;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.gsb-notification.show {
transform: translateX(0);
}
.gsb-notification--success {
background: #10b981;
color: white;
}
.gsb-notification--error {
background: #ef4444;
color: white;
}
</style>
`;

document.head.insertAdjacentHTML('beforeend', notificationStyles);

// Initialization Logic
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => {
if (typeof Swiper === 'undefined') {
setTimeout(() => new GoldbackSetBuilder(), 500);
} else {
new GoldbackSetBuilder();
}
});
} else {
if (typeof Swiper === 'undefined') {
setTimeout(() => new GoldbackSetBuilder(), 500);
} else {
new GoldbackSetBuilder();
}
}